export const crossSectionIsSteel = (crossSection: CrossSection) => {
  return crossSection.kind === 'Steel'
}

export const isTimberOrSteelCrossSectionKind = (
  cs: CrossSection | CLTCrossSection,
): cs is TimberCrossSection | SteelCrossSection => {
  return cs.kind === 'Timber' || cs.kind === 'Steel'
}

export const isCLTCrossSectionKind = (
  cs: CrossSection | CLTCrossSection,
): cs is CLTCrossSection => {
  return cs.kind === 'CLT'
}
